import { removerComponenteReact, renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact";
import { Dict } from "app/utils/Dict";
import React, { useEffect } from "react";
import { MenuSubConsultasDevolucoes, MenuSubConsultasDevolucoesContainer } from "./MenuSubConsultasDevolucoesContainer";


export const useMenuSubConsultasDevolucoes = (props: MenuSubConsultasDevolucoes) => {

    const onRenderizarMenuSubConsultasDevolucoes = (passos?: Dict<string, () => void>) => {

        if (props.devolucaoSelecionada == null) {
            removerComponenteReact("menu-sub-consulta-devolucao-orcamento-pesquisa-react")
        } else {
            renderizarComponentReact(
                <MenuSubConsultasDevolucoesContainer
                    orcamentoSelecionado={props.orcamentoSelecionado}
                    devolucaoSelecionada={props.devolucaoSelecionada}
                    onSelecionadoMenu={() => {
                        $("[container]").hide();
                    }}
                    onVoltar={props.onVoltar}
                    passos={passos ?? props.passos}
                />,
                "menu-sub-consulta-devolucao-orcamento-pesquisa-react",
                true
            );
        }
    }

    useEffect(() => {
        setTimeout(() => onRenderizarMenuSubConsultasDevolucoes());
        return () => {
            removerComponenteReact("menu-sub-consulta-devolucao-orcamento-pesquisa-react");
        };
    }, [props.devolucaoSelecionada]);

    return onRenderizarMenuSubConsultasDevolucoes;
}